import { render } from "./DocumentFolderShare.vue?vue&type=template&id=07141580"
import script from "./DocumentFolderShare.vue?vue&type=script&lang=js"
export * from "./DocumentFolderShare.vue?vue&type=script&lang=js"

import "./DocumentFolderShare.vue?vue&type=style&index=0&id=07141580&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__